import React, { useState } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { white, newBorder, textPrimary } from "../../utils/colors";
import { formatNumberWithCommas, removeCommas } from "../../utils/formatUtils";
import useIsMobile from "../../hooks/useIsMobile";

const FormControlPriceInput = ({
  label,
  value,
  onChange,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  placeholder,
  w,
  currencySymbol = "€",
  showSymbol = false,
  labelFontSize,
  ...inputProps
}) => {
  const [internalValue, setInternalValue] = useState(value);
  const isMobile = useIsMobile();

  const handleChange = (e) => {
    const raw = e.target.value;
    // Allow only numbers and dot
    const cleaned = raw.replace(/[^\d.]/g, "");
    setInternalValue(cleaned);
    onChange(removeCommas(cleaned));
  };

  const handleBlur = () => {
    if (internalValue === "") return;
    const numeric = parseFloat(removeCommas(String(internalValue)));
    if (!isNaN(numeric)) {
      const formatted = formatNumberWithCommas(numeric.toFixed(2));
      setInternalValue(formatted);
    } else {
      setInternalValue("");
    }
  };

  return (
    <FormControl
      mb={4}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
    >
      <FormLabel
        fontSize={labelFontSize || "sm"}
        position="relative"
        color={textPrimary}
      >
        {label}
        {isError && isTouched && (
          <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
        )}
      </FormLabel>
      <InputGroup>
        {showSymbol && (
          <InputLeftElement
            pointerEvents="none"
            color="gray.400"
            fontWeight="600"
            pl="1rem"
          >
            {currencySymbol}
          </InputLeftElement>
        )}
        <Input
          type="text"
          bg={white}
          value={internalValue}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
          fontSize={["1rem", "0.938rem"]}
          fontWeight="500"
          color={textPrimary}
          border={`1px solid ${newBorder}`}
          borderRadius="0.75rem"
          pl={showSymbol ? "2.5rem" : "1rem"}
          {...inputProps}
        />
      </InputGroup>
    </FormControl>
  );
};

export default FormControlPriceInput;
